import React from 'react';
import './App.css';
import Header from "./Header";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import Home from "./Home";
import Checkout from "./Checkout";

const App = () => {
  return(
    <Router>
      <div className="app">
        <Switch>
          <Route path="/checkout">
            <Header/>
             <Checkout/>
          </Route>

          <Route path="/login">
            <h1>Login Page</h1>
          </Route>

          <Route path="/">
            <Header/>
            <Home/>
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;